import React from 'react';
import { Link } from 'react-router-dom';
import { ComicPanel } from './ComicPanel';
import { Lock } from 'lucide-react';

export const ContentCard = ({ item, showLock = false }) => {
  const coverImage = item.imagePaths?.[0] || 'https://placehold.co/400x600/1e293b/F59E0B?text=No+Image';

  return (
    <Link to={`/read/${item.slug}`} data-testid={`content-card-${item.slug}`}>
      <ComicPanel className="group overflow-hidden aspect-[2/3] relative">
        <img
          src={coverImage}
          alt={item.title}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
          loading="lazy"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = 'https://placehold.co/400x600/1e293b/F59E0B?text=No+Image';
          }}
        />
        
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent opacity-100 group-hover:opacity-90 transition-opacity" />
        
        {/* Title */}
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <h3 className="font-black uppercase tracking-tight text-white text-lg leading-tight">
            {item.title}
          </h3>
          {item.caption && (
            <p className="text-slate-400 text-sm mt-1 line-clamp-2">{item.caption}</p>
          )}
        </div>

        {/* Members Only Badge */}
        {showLock && item.isMembersOnly && (
          <div className="absolute top-3 right-3 bg-yellow-500 text-black p-2 rounded-none">
            <Lock className="w-4 h-4" />
          </div>
        )}
      </ComicPanel>
    </Link>
  );
};
